/*
 * @Author: Gang Jiang 
 * @Date: 2025-02-28 09:39:08 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2025-02-28 13:48:50
 */
<template>
  <div class="help-page">
    <breadcrumbs url="about-artemis-ads" lastTitle="Publisher FAQ"/>
    <div class="docs">
      <h1>Getting Started with Artemis Ads</h1>
      <h2>What is Artemis Ads?</h2>
      <p>
        Artemis Ads is an affiliate marketing program that allows you to earn
        commissions by promoting products from Artemis Ads’ advertisers. As an
        affiliate, you’ll receive a commission for every sale made through your
        unique Artemis Ads affiliate links.
      </p>
      <h2>How do I join Artemis Ads?</h2>
      <p>To become an Artemis Ads Affiliate, follow these steps:</p>
      <ol>
        <li>
          Apply by filling out the application form on the Artemis Ads website.
        </li>
        <li>Once approved, you’ll gain access to your affiliate dashboard.</li>
        <li>Start promoting Amazon products and earning commissions.</li>
      </ol>
      <h2>How do I promote Artemis Ads products?</h2>
      <p>
        There are multiple ways to promote Artemis Ads products and services,
        including:
      </p>
      <ul>
        <li>Writing blog posts</li>
        <li>Creating videos</li>
        <li>Writing product reviews</li>
        <li>Sharing on social media platforms</li>
      </ul>
      <h2>Do I need a website to promote Artemis Ads products?</h2>
      <p>No.</p>
      <p>Having a website is not required to join Artemis Ads.</p>
      <p>
        However, a website or blog can help drive more traffic to your affiliate
        links and increase your earnings.
      </p>
    </div>
  </div>
</template>
<script setup>
import Breadcrumbs from '../breadcrumbs.vue'
</script>